export const files = {
  // Remove file extension for new resumes that don't specify a title
  formatDefaultResumeTitle: (resumeFile: File) =>
    resumeFile.name.replace(/\.[^/.]+$/, ""),
};
